import FormJaivana from 'dashboard_jaivana_v1';

/**
 *
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */

class CustomCalidadProduccion extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm = this.initForm.bind(this);
        this.successTablaItemFichas = this.successTablaItemFichas.bind(this);
        this.setButtonObservacion = this.setButtonObservacion.bind(this);
        this.setButtonValorActual = this.setButtonValorActual.bind(this);
        this.uploadTable = this.uploadTable.bind(this);
        this.id_valor_actual = 0;
        this.valMax = 0;
        this.valMin = 0;
        this.valido = true;
        this.envasarFicha = this.envasarFicha.bind(this);
        this.successProximoConteo = this.successProximoConteo.bind(this);
        this.successGrabarValorActual = this.successGrabarValorActual.bind(this);
        this.guardarValor = this.guardarValor.bind(this);
        this.guardarObservacion = this.guardarObservacion.bind(this);
        this.successGrabarObservacion = this.successGrabarObservacion.bind(this);
        this.ajusteFicha = this.ajusteFicha.bind(this);
        this.autorizarAjustesID = this.autorizarAjustesID.bind(this);
        this.valorActualChange = this.valorActualChange.bind(this);
        this.observacionChange = this.observacionChange.bind(this);
        this.tablaItemsFichas = this.tablaItemsFichas.bind(this);
        this.proximoConteo = this.proximoConteo.bind(this);
        //this.retornaFichasEtapas        = this.retornaFichasEtapas.bind(this);
        //this.successRetornaFichasEtapas = this.successRetornaFichasEtapas.bind(this);
        this.gridOptionsFichasEtapas = Object.assign({}, this.gridOptions);
        this.setButtonVer = this.setButtonVer.bind(this);
        this.verEtapa = this.verEtapa.bind(this);
        this.successVerEtapa = this.successVerEtapa.bind(this);
        this.successFichaIdSet = this.successFichaIdSet.bind(this);
        this.gridOptionsItems = Object.assign({}, this.gridOptions);
        this.fichaIdSet = this.fichaIdSet.bind(this);
        this.observacion = '';
        this.valido = true;
        this.openModal = true;
        this.arrayCantidades = [];
        this.successAjustesFichaId = this.successAjustesFichaId.bind(this);
        this.enviaraPesajeSinAjustes = this.enviaraPesajeSinAjustes.bind(this);
        this.funcionParaCerrarLaEtapa = this.funcionParaCerrarLaEtapa.bind(this);
        this.verFormula               = this.verFormula.bind(this);
        this.successVerFormula        = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula    = Object.assign({}, this.gridOptions);
    }

    initForm() {
        console.log('Calidad @version: 1.01.0054 @author: Mario A. Sepúlveda; @updateBy: Sebastian Rios Echverri');
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.fichaIdSet();
        this.tablaItemsFichas();
        this.proximoConteo();
        //this.retornaFichasEtapas();
        this.getField('btnAjuste').setClick(this.ajusteFicha);
        this.getField('btnEnvasar').setClick(this.envasarFicha);
        this.getField('btnAutorizar').setClick(this.autorizarAjustesID);
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    fichaIdSet() {
        this.getField('value').setValue(this.props.data.id_ficha);
        if (this.getField('value').getValue() !== '') {
            let datos = {
                datos:{
                    value: this.getField('value').getValue(),
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successFichaIdSet,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = 'servicio_traer_datos_de_ficha_calidad';
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: body,
                    success: this.successFichaIdSet,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        }
    }
    successFichaIdSet(data) {
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0) {
            this.getField('listaFichaCalidad').setVisible(true);
            this.getField('listaFichaCalidad').setItemsFichas(data.model);
        } else {
            this.getField('listaFichaCalidad').setVisible(false);
        }
    }
    tablaItemsFichas() {
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-calidad', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTablaItemFichas,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '265-Retorna_items_tabla_fichascalidad';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successTablaItemFichas,
                error: this.error_,
                general: this.generalFormat
            });*/

    }

    proximoConteo() {
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-calidad', operacion: 'proximoconteo', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successProximoConteo,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '265-Retorna_fichas_calidad_proximoconteo';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successProximoConteo,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    setButtonVer(props) {
        let button = document.createElement("input");
        button.onclick = () => this.verEtapa(props);
        button.setAttribute("id", 'button_aprove_');
        button.setAttribute("style", "width:60px; height: 20px%; background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");//,"width:100%; height: 100%; background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
        button.setAttribute("type", "button");
        button.setAttribute("value", "Ver");
        return this.createElementJaivana(button);
    }

    verEtapa(props) {
        this.getField('modal_fichas_etapas').handleClickOpen();
        this.getField('etapa_id').setValue(props.data.etapa_id);
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha)
        if (this.getField('produccion_fichas_id').getValue() !== '' && this.getField('etapa_id').getValue() !== '') {
            let body = {
                produccion_fichas_id: this.getField('produccion_fichas_id').getValue(),
                etapa_id: this.getField('etapa_id').getValue(),
            }
            this.generalFormat.nombre_accion = '265-Retorna_fichas_itemsetapa';
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successVerEtapa,
                error: this.error_,
                general: this.generalFormat
            });
        }
    }
    successVerEtapa(data) {
        if (data.estado_p === 200) {
            this.getField('costo').setValue(data.data[0].costo_etapa);
            this.getField('total_cantidad').setValue(data.data[0].total_cantidad);
            this.getField('total_agregado').setValue(data.data[0].total_agregada);
            this.getField('total_pendiente').setValue(data.data[0].total_pendiente);
            this.getField('porcentaje').setValue(data.data[0].porcentaje);
            if (data.data[0].items && data.data[0].items.length > 0) {
                this.gridOptionsItems['rowData'] = data.data[0].items
                this.getField('tabla_items').initData(this.gridOptionsItems);

            } else {
                this.getField('tabla_items').toggle(false);
            }
        }
    }

    autorizarAjustesID() {
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        if (this.getField('produccion_fichas_id').getValue() !== '' &&
            this.getField('proceso_id').getValue() !== '' &&
            this.getField('actividad_configuracion_id').getValue() !== '' &&
            this.getField('actividad_id').getValue() !== '') {
            let datos = {
                datos:{
                    id_formulario: this.formId,
                    produccion_fichas_id: this.getField('produccion_fichas_id').getValue(),
                    proceso_id: this.getField('proceso_id').getValue(),
                    actividad_configuracion_id: this.getField('actividad_configuracion_id').getValue(),
                    actividad_id: this.getField('actividad_id').getValue(),
                }
            }
            this.getField('btnAutorizar').setDisabled(true);

            this.generalFormatPmv = { tipo_servicio: 'prod-calidad', operacion: 'investigaciondesarrollo', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successCloseEstage,
                error: this.error_,
                general: this.generalFormatPmv
            });

            /*this.generalFormat.nombre_accion = '265-Crear_investigaciondesarrollo_ficha_calidad';
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: body,
                    success: this.successCloseEstage,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        }
    }


    envasarFicha() {

        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);

         let datos = {
            datos:{
                value: this.props.data.id_ficha
            }
        } 
        //this.getField('btnEnvasar').setDisabled(true);

        this.generalFormatPmv = { tipo_servicio: 'prod-ajustes', operacion: 'agregado', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successAjustesFichaId,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '265-Servicio_buscar_produccion_fichas_items_por_ficha_id';
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method: 'GET',
            body: body,
            success: this.successAjustesFichaId,
            error: this.error_,
            general: this.generalFormat
        });*/
    } 

    successAjustesFichaId(data) {
        if (data.estado_p === 200) {
            //console.log('entro a ajustesfichais 200',data);
            this.funcionParaCerrarLaEtapa();

        } else if (data.estado_p === 404) {
            //console.log('entro a ajustesfichaid 404',data);
            this.openModal = true;
            this.getField('confirmModalCustom').setTitleAndContent('Enviar a Pesaje', 'La ficha se enviará a pesaje sin Ajustes, ¿Desea continuar?');
            this.getField('confirmModalCustom').setClickDialog(this.enviaraPesajeSinAjustes);
            this.getField('confirmModalCustom').toggle(true);

        }
    }

    enviaraPesajeSinAjustes() {
        this.getField('confirmModalCustom').toggle(false);    
        if(this.openModal === true){
            this.openModal = false;
            this.funcionParaCerrarLaEtapa();
        }
    }

    funcionParaCerrarLaEtapa() {
        this.valido = true;
        //console.log('entro a la funcion para cerrar la etapa');
        this.gridOptions['rowData'].map((item, i) => {
            console.log("FF = ",this.gridOptions['rowData'][i]);
            if (parseFloat(this.gridOptions['rowData'][i].valor_maximo) > 0 && parseFloat(this.gridOptions['rowData'][i].valor_minimo) > 0 && parseFloat(this.gridOptions['rowData'][i].valor_actual) === 0) {
                this.valido = false;
                this.getField('confirmModalCustom').setTitleAndContent('Campo vacio', `el Valor actual de ${item.variable} no pude ser cero`);//antes de ser eliminado, se ejecuta la funcion que pide confirmacion
                this.getField('confirmModalCustom').setClickDialog(this.uploadTable);
                this.getField('confirmModalCustom').toggle(true);
            } else if (parseFloat(this.gridOptions['rowData'][i].valor_maximo) === 0 && parseFloat(this.gridOptions['rowData'][i].valor_minimo) === 0 &&
                this.gridOptions['rowData'][i].observaciones === '.') {
                this.valido = false;
                this.getField('confirmModalCustom').setTitleAndContent('Campo vacio', `La Observación para ${item.variable} , es requerida`);//antes de ser eliminado, se ejecuta la funcion que pide confirmacion
                this.getField('confirmModalCustom').setClickDialog(this.uploadTable);
                this.getField('confirmModalCustom').toggle(true);
            }
            return null;
        });


        if (this.valido) {
            if (this.getField('produccion_fichas_id').getValue() !== '' &&
                this.getField('proceso_id').getValue() !== '' &&
                this.getField('actividad_configuracion_id').getValue() !== '' &&
                this.getField('actividad_id').getValue() !== '') {

                let datos = {
                    datos:{
                        id_formulario: this.formId,
                        produccion_fichas_id: this.getField('produccion_fichas_id').getValue(),
                        actividad_id: this.getField('actividad_id').getValue(),
                        proceso_id: this.getField('proceso_id').getValue(),
                        actividad_configuracion_id: this.getField('actividad_configuracion_id').getValue(),
                    }
                }
                this.generalFormatPmv = { tipo_servicio: 'prod-calidad', operacion: 'pesaje', operacion_tipo: 'crear' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method:'POST',
                    body: datos,
                    success: this.successCloseEstage,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
                /*this.generalFormat.nombre_accion = '265-Crear_ficha_calidad_pesaje';
                this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method: 'POST',
                        body: body,
                        success: this.successCloseEstage,
                        error: this.error_,
                        general: this.generalFormat
                    });*/
            } else {
                this.alertGeneral.toggle(true, 'Falta algún item', "error");
            }
        } else {
            this.alertGeneral.toggle(true, 'Algún item esta por fuera del rango permitido y se requiere de una observación para continuar', "error");
        } 
    }

    uploadTable() {
        this.getField('confirmModalCustom').toggle(false);
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-calidad', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTablaItemFichas,
            error: this.error_,
            general: this.generalFormatPmv
        });

    }

    successProximoConteo(data) {
        if (data.estado_p === 200){
            console.log('entro a suscces_proximo conteo',data);
            this.getField('conteo').setValue(data.model[0].conteo);
            this.getField('kilos_recibidos').setValue(data.model[0].cantidad_kilos);
        }
    }

    successTablaItemFichas(data) {
        this.getField('btnAjuste').setDisabled(false);
        this.getField('btnEnvasar').setDisabled(false);
        this.getField('btnAutorizar').setDisabled(false);
        if (data.estado_p === 200) {
            this.gridOptions['rowData'] = [];
            this.getField('tablaCalidad').initData(this.gridOptions);
            this.getField('valor_digitado').setValue('');
            this.getField('observaciones').setValue('');
            let configCell = new Map();
            this.tamanoDatos = data.model.length;
            configCell.set('valor_actual', { cellRenderer: this.setButtonValorActual, singleClickEdit: true, cellStyle: { backgroundColor: "rgb(238,238,238)", borderRadius: "5px", color: 'rgb(0, 86, 201)' }, onCellValueChanged: this.valorActualChange, editable: true, field: 'Valor actual' });
            configCell.set('observaciones', { cellRenderer: this.setButtonObservacion, singleClickEdit: true, cellStyle: { backgroundColor: "rgb(238,238,238)", borderRadius: "5px", color: 'rgb(0, 86, 201)' }, onCellValueChanged: this.observacionChange, editable: true, field: 'Observaciones' });
            this.gridOptions['rowData'] = data.model;
            this.arrayCantidades = data.model;
            this.getField('tablaCalidad').initData(this.gridOptions, configCell);
        } else
            this.getField('tablaCalidad').toggle(false);
    }

    valorActualChange(props) {
        if (props.oldValue !== props.newValue && props.newValue !== '') {
            let id = props.data.id;
            let minimo = props.data.valor_minimo;
            let maximo = props.data.valor_maximo;
            let valor_actual = props.newValue;
            if (valor_actual !== '' && parseFloat(valor_actual) && parseFloat(valor_actual) >= 0) {
                if (parseFloat(valor_actual) >= minimo && parseFloat(valor_actual) <= maximo) {
                    let obs = '';
                    if (props.data.observaciones === '')
                        obs = '.';
                    else
                        obs = props.data.observaciones;
                    this.guardarValor(id, parseFloat(valor_actual), obs);
                } else {
                    let obs = '';
                    if (props.data.observaciones === '') {
                        obs = '.';
                        this.guardarValor(id, parseFloat(valor_actual), obs);
                        this.alertGeneral.toggle(true, 'Debe ingresar una observación', "error");
                    } else
                        obs = props.data.observaciones;
                    this.guardarValor(id, parseFloat(valor_actual), obs);
                }
            } else {
                this.alertGeneral.toggle(true, 'El campo no cumple con el formato deseado', "error");
                this.gridOptions.rowData[parseInt(props.node.id)][props.column.colId] = props.oldValue;
            }
        }
    }

    observacionChange(props) {
        if (props.oldValue !== props.newValue && props.newValue !== '') {
            if (props.newValue.length > 5) {
                let id = props.data.id;
                let observacion = props.newValue;
                this.guardarObservacion(id, observacion);
            } else {
                this.alertGeneral.toggle(true, 'La observación debe contener mínimo 5 caracteres', "error");
                this.uploadTable();
            }
        }
    }

    setButtonValorActual(props) {
        let valor_actual = props.data.valor_actual;
        if (valor_actual === null)
            this.valido = false;
        let div = document.createElement("div");
        let label = document.createElement("label");
        label.textContent = valor_actual;
        div.appendChild(label);
        return this.createElementJaivana(div);
    }

    setValorActual(id, valor_minimo, valor_maximo) {
        this.id_valor_actual = id;
        this.valMax = valor_maximo;
        this.valMin = valor_minimo;
        this.getField('modalCalidad').handleClickOpen(this.openModalGrabar.bind(this))
    }

    openModalGrabar() {
        this.getField('btnGuardarValor').setClick(this.guardarValor)
    }

    guardarValor(idCell, valor_actual, obs) {
        this.getField('valor_digitado').setValue(valor_actual);
        this.getField('observaciones').setValue(obs);
        let datos = {
            datos:{
                id_formulario: this.formId,
                valor_digitado: this.getField('valor_digitado').getValue(),
                observaciones: this.getField('observaciones').getValue(),
                actividad_id: this.getField('actividad_id').getValue(),
                id: idCell
            }
        }
        
        this.generalFormatPmv = { tipo_servicio: 'prod-calidad', operacion: 'valoractual', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successGrabarValorActual,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'servicio_actualizar_valor_digitado_ficha_calidad';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: body,
                success: this.successGrabarValorActual,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successGrabarValorActual(data) {
        if (data.estado_p === 200)
            this.uploadTable();
    }

    setButtonObservacion(props) {
        let observaciones = props.data.observaciones;
        let div = document.createElement("div");
        let label = document.createElement("label");
        label.textContent = observaciones;
        if ((props.data.valor_actual > props.data.valor_maximo || props.data.valor_actual < props.data.valor_minimo) && (props.data.observaciones.length < 5)) {
            div.setAttribute('class', 'labelRed');
            this.valido = false;
        }
        div.appendChild(label);
        return this.createElementJaivana(div);
    }

    setObservacion(id, dato) {
        this.id_observacion = id;
        this.getField('modalObservacion').handleClickOpen(this.openModalGrabarOb.bind(this))
    }

    openModalGrabarOb() {
        this.getField('btnGuardarObservacion').setClick(this.guardarObservacion)
    }

    guardarObservacion(idCell, observacion) {
        this.getField('observaciones').setValue(observacion)
        let datos = {
            datos:{
                id_formulario: this.formId,
                observaciones: this.getField('observaciones').getValue(),
                actividad_id: this.getField('actividad_id').getValue(),
                id: idCell
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-calidad', operacion: 'observacion', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successGrabarObservacion,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '265-Actualiza_observaciones_fichacalidad';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: body,
                success: this.successGrabarObservacion,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successGrabarObservacion(data) {
        if (data.estado_p === 200)
            this.uploadTable();
    }

    ajusteFicha() {
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        if (this.getField('produccion_fichas_id').getValue() !== '' &&
            this.getField('proceso_id').getValue() !== '' &&
            this.getField('actividad_configuracion_id').getValue() !== '' &&
            this.getField('actividad_id').getValue() !== '') {
            let datos = {
                datos:{
                    id_formulario: this.formId,
                    produccion_fichas_id: this.getField('produccion_fichas_id').getValue(),
                    proceso_id: this.getField('proceso_id').getValue(),
                    actividad_configuracion_id: this.getField('actividad_configuracion_id').getValue(),
                    actividad_id: this.getField('actividad_id').getValue(),
                }
            }
            this.getField('btnAjuste').setDisabled(true);

            this.generalFormatPmv = { tipo_servicio: 'prod-calidad', operacion: 'ajuste', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successCloseEstage,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '265-Crear_ajuste_calidad';
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: body,
                    success: this.successCloseEstage,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        }
    }
}

FormJaivana.addController('prod-calidad', CustomCalidadProduccion);
export default CustomCalidadProduccion;